import React, { useEffect, useState } from "react";
import { Button, CircularProgress, makeStyles } from "@material-ui/core";
import { Form, useFormik, FormikProvider } from "formik";
import axios from "axios";
import Cookies from "js-cookie";
import ThemeFrom from "./CcmodeSetupNew/FormEdit/ThemeFrom";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import validationSchemaEditTheme from "./CcmodeSetupNew/FormModel/validationSchemaEditTheme";
import kycFormModel from "./CcmodeSetupNew/FormModel/kycFormModel";
import { toast } from "react-toastify";
import { TfiSave } from "react-icons/tfi";
import { BsArrowLeftShort } from "react-icons/bs";
import { useCCmodeSettingContext } from "../../../context/ccmodeSettingContext";
import UnSavedChangesPopUp from "../Popup/UnSavedChangesPopUp.jsx";
import { Skeleton } from "@material-ui/lab";
import { isEqual } from "lodash";

const { formId, formField } = kycFormModel;

const useStyles = makeStyles((theme) => ({
    saveBtn: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.up("xs")]: {
            flexDirection: "column",
            alignItems: "start",
            gap: "10px",
        },
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            alignItems: "center",
        },
    },
}));

export default function CcmodeThemeSetting(props) {
    const classes = useStyles();

    const { activeKey ,setIsFormChanged, showFormChangePopUp, setShowFormChangePopUp, nextKey, setNextKey, setActiveKey } = useCCmodeSettingContext();

    const currentValidationSchema = validationSchemaEditTheme[0];
    const [companylogo, setCompanyLogo] = useState();
    const [backgroundimage, setBackGroundImage] = useState();

    function _handleSubmit(values, actions) {
        actions.setSubmitting(true);
        const formData = new FormData();
        if (companylogo) {
            formData.set("comapny_logo", companylogo[0]);
        }
        formData.set("white_label_logo", values?.white_label_logo || "");
        if (backgroundimage) {
            formData.set("backgroundimage", backgroundimage[0]);
        }
        formData.set("background_image", values?.background_image || "");
        if (props.userinfo.id) {
            formData.set("CustomerId", props.userinfo.id);
        }
        if (values.theme) {
            formData.set("Theme", values.theme);
        }
        if (values.wl_primarycolor) {
            formData.set("NaturalPrimaryColor", values.wl_primarycolor);
        }
        if (values.n_fontcolor) {
            formData.set("NaturalFontColor", values.n_fontcolor);
        }
        if (values.lab_primary) {
            formData.set("LabPrimaryColor", values.lab_primary);
        }
        if (values.lab_fontcolor) {
            formData.set("LabFontColor", values.lab_fontcolor);
        }
        if (values.nav_bar_color) {
            formData.set("nav_bar_color", values.nav_bar_color);
        }
        if (values.timeZone) {
            formData.set("timeZone", values.timeZone);
        }
        if (values.background_color) {
            formData.set("background_color", values.background_color);
        }
        if (values.nav_bar_font) {
            formData.set("nav_bar_font", values.nav_bar_font);
        }
        formData.set("displayName", values.displayName || "");

        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/insert-update-ccmode-setting`,
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            data: formData,
        })
            .then((res) => {
                if (res.data.success) {
                    toast.dismiss();
                    toast.success(
                        "Your Client-Centric Mode Theme Setting Updated Successfully."
                    );
                    toast.success(
                        "Please login again in CC-Mode to see the changes."
                    );

                    handlePopUpOnSuccess();

                    setTimeout(() => {
                        const container = document.getElementById(
                            "themesetting"
                        );
                        if (container) {
                            container.scrollIntoView({
                                top: 0,
                                left: 0,
                                behavior: "smooth",
                            });
                        }
                    }, 100);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
                if (error?.response?.data?.message) {
                    toast.error(error?.response?.data?.message);
                }
            })
            .finally(() => {
                actions.setSubmitting(false)
            });
    }

    const [initialFormObj, setInitialFormObj] = useState({
            white_label_logo: props.ccmodesetting.Logo,
            theme: props.ccmodesetting.Theme,
            wl_primarycolor: props.ccmodesetting.NaturalPrimaryColor,
            n_fontcolor: props.ccmodesetting.NaturalFontColor,
            lab_primary: props.ccmodesetting.LabPrimaryColor,
            lab_fontcolor: props.ccmodesetting.LabFontColor,
            displayName: props.ccmodesetting.displayName,
            background_image: props.ccmodesetting.background_image,
            nav_bar_color: props.ccmodesetting.nav_bar_color,
            background_color: props.ccmodesetting.background_color,
            nav_bar_font: props.ccmodesetting.nav_bar_font,
            timeZone: props.ccmodesetting.timeZone,
    });

    const formik = useFormik({
        initialValues: initialFormObj,
        enableReinitialize: true,
        validationSchema: currentValidationSchema,
        onSubmit: _handleSubmit,
    });

    useEffect(() => {
        if (props.ccmodesetting) {
            const isMatched = isEqual(
                initialFormObj,
                formik.values
            );

            if (!isMatched) {
                setIsFormChanged(true);
            } else{
                setIsFormChanged(false);
            }
        }
    }, [formik.values]);

    function handlePopUpOnSuccess(){
        setInitialFormObj(formik.values);
        setIsFormChanged(false);
        setShowFormChangePopUp(false);
        if(nextKey){
            setActiveKey(nextKey);
            setNextKey(null);
        }
    }

    if(!props.ccmodesetting){
        return <>
            <Skeleton animation="wave" />
            <Skeleton animation="wave" />
            <Skeleton animation="wave" />
            <Skeleton animation="wave" />
            <Skeleton animation="wave" />
        </>
    }

    return (
        <div className="row">
            <div className="col-12 ccmode-setting-sticky-header">
                <div className="setting-title pb-3 pt-2">
                    <span
                        className="cursor-pointer text-hover-primary small setting-title"
                        onClick={() => window.history.go(-1)}
                    >
                        <BsArrowLeftShort /> Back to dashboard
                    </span>
                </div>
                <div
                    className={`col-12 px-0 setting-title pb-5 border-bottom ${classes.cardHeader}`}
                >
                    <div className="d-flex flex-column">
                        <span>CCMODE THEME SETTING</span>
                        <span className="small text-capitalize">
                            client centric mode theme setting
                        </span>
                    </div>
                    <div>
                        <Button
                            disabled={formik.isSubmitting}
                            variant="contained"
                            color="primary"
                            className={classes.saveBtn}
                            onClick={formik.submitForm}
                        >
                            <TfiSave className="mr-3" size={13} />
                            {props.language.SETTING_PASSWORD_SAVE}
                            {formik.isSubmitting && (
                                <CircularProgress
                                    size={16}
                                    className={"ml-3"}
                                />
                            )}
                        </Button>
                    </div>
                </div>
            </div>
            <div className="col-12 pt-4">
                <FormikProvider value={formik}>
                    <Form id={formId}>
                        <ThemeFrom
                            formField={formField}
                            values={formik.values}
                            setFieldValue={formik.setFieldValue}
                            setCompanyLogo={setCompanyLogo}
                            setBackGroundImage={setBackGroundImage}
                            language={props.language}
                            ccmodesetting={props.ccmodesetting}
                            displayName={props.displayName}
                        />
                    </Form>
                </FormikProvider>
            </div>
            <UnSavedChangesPopUp
                show={showFormChangePopUp && activeKey === "ccmodetheme"}
                onClose={() => {
                    formik.resetForm();
                    setIsFormChanged(false);
                    setShowFormChangePopUp(false);
                    if(nextKey){
                        setActiveKey(nextKey);
                        setNextKey(null);
                    }
                }}
                onCross={()=>{
                    setShowFormChangePopUp(false);
                }}
                message="you have unsaved changes in theme setting"
                handleSave={formik.submitForm}
            />
        </div>
    );
}
